import { render, staticRenderFns } from "./SidebarModuleInfo.vue?vue&type=template&id=892164ac&"
import script from "./SidebarModuleInfo.vue?vue&type=script&lang=js&"
export * from "./SidebarModuleInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports